"use client";

import { Mail, MessageCircleMore } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card } from "@/components/ui/card";
export default function AdditionalContactInformation() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const contactItems = [{
    id: 1,
    icon: MessageCircleMore,
    // WhatsApp-ähnliches Icon
    label: "Telefon",
    value: "0160 3284613"
  }, {
    id: 2,
    icon: Mail,
    label: "E-Mail",
    value: "info.namo@icloud.com"
  }];
  return;
}